import { ENABLE_COLLECTIONS_PAGINATION_240711 } from "@faire/web-api/indigofair/settings/ENABLE_COLLECTIONS_PAGINATION_240711";

import { getSettingValueWithoutAssignment } from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingEnableCollectionsPagination = (): boolean => {
  return getSettingValueWithoutAssignment(
    ENABLE_COLLECTIONS_PAGINATION_240711,
    false
  );
};
